import { Injectable } from '@angular/core';

import { LimitOptionModel } from '../../_interfaces';

@Injectable()
export class LimitOptionService {

  private sortOption: LimitOptionModel[] = [];
}
